import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
// constants
import ROLES from '../../constants/Roles';
// components
import AutoComplete from '../Common/AutoComplete';
import { Card, CardActions, CardHeader } from 'material-ui/Card';
import AssetSegmentAdmin from '../Asset/AssetSegmentAdmin';
import ContactListItem from '../Contact/ContactListItem';
import DetailView from '../Common/DetailView';
import Dialog from 'material-ui/Dialog';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import { List } from 'material-ui/List';
import LoadingDialog from '../Common/LoadingDialog';
import LocationListItem from '../Location/LocationListItem';
import MenuItem from 'material-ui/MenuItem';
import LocationIcon from 'material-ui/svg-icons/communication/location-on';
import PersonIcon from 'material-ui/svg-icons/social/person';
// icons
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
// business logic
import ContactActions from '../../actions/ContactActionCreator';
import ContactStore from '../../stores/ContactStore';

import LocationActions from '../../actions/LocationActionCreator';
import LocationStore from '../../stores/LocationStore';

import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';
import VenueContactStore from '../../stores/VenueContactStore';
import VenueLocationStore from '../../stores/VenueLocationStore';
import VenueAssetStore from '../../stores/VenueAssetStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';
import SelectAsset from '../Asset/SelectAsset';

let timeout;

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)',
};


const VenueSettings = React.createClass({

    getInitialState: function () {

        return {
            open: false,
            searchText: '',
            details: {
                id: '',
                name: '',
                description: '',
            },
            locations: [],
            locationList: undefined,
            contacts: [],
            contactList: [],
            assets: [],
            assetList: [],
            dialog: {
                open: false,
                value: null,
            },
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/venue/' + this.props.id,
                    icon: <InfoIcon />,
                    label: 'Preview',
                },
                {
                    type: 'divider'
                },
                {
                    link: '/dashboard/venue/' + this.props.id + '/edit',
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type: 'deleteDialog',
                    dialogType: 'menu',
                    value: this.props.id,
                    title: 'Delete ',
                    deleteAction: this._onDelete,
                    message: (
                                <span>
                                    Are you sure you want to delete this venue?
                                </span>
                            ),
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }

            ],
            links: {
                back: '/dashboard/venue/' + this.props.id,
                edit: '',

            }
        }
    },

    componentDidMount: function() {
        VenueStore.addChangeListener(this._onChange);
        VenueActions.getById(this.props.id);

        VenueLocationStore.addChangeListener(this._onLocationChange);
        VenueActions.getLocations(this.props.id);

        this.listeners = [
            LocationStore.addListener(this._onLocationListChange),
            VenueAssetStore.addListener(this.onVenueAssetChange)
        ];

        LocationActions.getAll();
        VenueActions.listAssets(this.props.id);

        VenueContactStore.addChangeListener(this._onVenueContactChange);
        VenueActions.getContacts(this.props.id);

        ContactStore.addChangeListener(this._onContactListChange);

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});

    },

    componentWillUnmount: function() {
        VenueStore.removeChangeListener(this._onChange);
        VenueContactStore.removeChangeListener(this._onVenueContactChange);
        VenueLocationStore.removeChangeListener(this._onLocationChange);
        ContactStore.removeChangeListener(this._onContactListChange);
        this.listeners.forEach(listener => listener.remove());
    },

    render: function () {
        // handle dialogs
        let dialogActions = [
            <FlatButton
                key="btn_cancel"
                label="Cancel"
                onTouchTap={this._closeDialog}
            />,
            <FlatButton
                key="btn_submit"
                label="Submit"
                onTouchTap={this._dialogSave}
                disabled={this.state.dialog.value === null}
            />,
        ];
        let activeDialog = '';
        switch (this.state.dialog.open) {
            case 'location':
                let dialogProps = { title: 'Add location', open: true };
                if (this.state.locationList === undefined) {
                    dialogProps.buttonAction = this._closeDialog;
                    activeDialog = <LoadingDialog {...dialogProps} />
                } else {
                    dialogProps.actions = dialogActions;
                    dialogProps.onRequestClose = this._closeDialog;

                    activeDialog = <Dialog {...dialogProps} >
                        <AutoComplete
                            floatingLabelText="Location"
                            maxSearchResult={5}
                            dataSource={this.state.locationList}
                        />
                    </Dialog>
                }
                break;
                
            case 'contact':
                let props = {
                    title: "Add Contact", 
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog,
                    actions: [
                        <FlatButton
                            key="btn_cancel"
                            label="Cancel"
                            onTouchTap={this._closeDialog}
                        />,
                        <FlatButton
                            key="btn_submit"
                            label="Submit"
                            onTouchTap={this._dialogSave}
                            disabled={this.state.dialog.value === null}
                        />,
                    ]
                };
                activeDialog = (
                    <Dialog {...props} >
                        <AutoComplete
                            floatingLabelText="Contact"
                            maxSearchResults={5}
                            dataSource={this.state.contactList}
                            onUpdateInput={this._onContactAutocomplete}
                        />
                    </Dialog>
                );
                break;

            case 'asset':
                activeDialog = (
                    <Dialog
                        title="Add attachment"
                        open={true}
                        modal={false}
                        onRequestClose={this._closeDialog}
                        actions={[
                            <FlatButton
                                key="btn_cancel"
                                label="Cancel"
                                onTouchTap={this._closeDialog}
                            />,
                            <FlatButton
                                key="btn_add"
                                label="Add"
                                onTouchTap={this._dialogSave}
                                disabled={!this.state.dialog.value}
                            />
                        ]}
                    >
                        <SelectAsset
                            label="Attachment"
                            maxSearchResult={5}
                            clearOnSelect={false}
                            onSelect={(name, id) => this.onDialogSelect(id)}
                            onUpdate={() => this.onDialogSelect()}
                        />
                    </Dialog>
                );
                break;
                
            default: break;
        }

        return (
            <DetailView
                title={this.state.details.name}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title='Locations'
                            subtitle='manage locations for this venue'
                            avatar={<LocationIcon {...iconProps}/>}
                        />
                        <List>
                            {this.state.locations.map((location) => (
                                    <div key={location.id}>
                                        <LocationListItem
                                            key={location.id}
                                            data={location}
                                            actions={this._getLocationActions(location)}
                                        />
                                    </div>
                            ), this)}
                        </List>
                        <CardActions>
                            <FlatButton
                                key="addLocation"
                                label="Add"
                                href={`/dashboard/venue/${this.props.id}/location`}
                                style={{textAlign:'center'}}
                            />
                        </CardActions>
                    </Card>

                    <Card className="cent-card">
                        <CardHeader
                            title='Contacts'
                            subtitle='manage contacts for this venue'
                            avatar={<PersonIcon {...iconProps}/>}
                        />
                        <List>
                            {this.state.contacts.map(function(contact) {
                                let loading = (!!contact.loading ? <LinearProgress /> : null);
                                return (
                                    <div key={contact.id}>
                                        <ContactListItem data={contact} actions={this._getContactActions(contact)} />
                                        {loading}
                                    </div>
                                );
                            }, this)}
                        </List>
                        <CardActions>
                            <FlatButton key="addContact" label="Add" onTouchTap={this._dialogOpener('contact')} />
                        </CardActions>
                    </Card>
                    <AssetSegmentAdmin
                        assets={this.state.assets}
                        addAction={this._dialogOpener('asset')}
                        deleteAction={(assetId) => VenueActions.removeAsset(this.props.id, assetId)}
                    />
                </div>
                {activeDialog}
                <ErrorSnackbar/>
            </DetailView>
        )
    },

    _onChange: function() {
        let details = VenueStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    },

    _onLocationChange: function() {
        let locations = VenueLocationStore.getByVenue(this.props.id);
        if (locations !== undefined) {
            let locationsCopy = locations.filter(function(e) { return e !== undefined; });
            this.setState({locations: locationsCopy});
        }
    },

    _onLocationListChange: function() {
        let locations = LocationStore.getAll();
        if (locations !== undefined) {
            let locationList = locations.map(function(location) {
                let click = this.onDialogSelect.bind(this, location);
                return {
                    id: location.id,
                    name: location.name,
                    text: location.name,
                    value: <MenuItem key={location.id} value={location.id} primaryText={location.name} onTouchTap={click} />
                };
            }, this);
            this.setState({locationList: locationList});
        }
    },
    
    _getLocationActions: function(location) {
        return [
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: location.id,
                menuTitle: 'Remove',
                title: 'Remove location',
                deleteAction: this._removeLocation,
                message: <span>Are you sure you wish to delete "{location.name}" ?</span>,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },
    
    _onVenueContactChange: function() {
        let contacts = VenueContactStore.getByVenue(this.props.id);
        if (contacts !== undefined) {
            let state = assign(this.state, {contacts: contacts});
            this.setState(state);
        }
    },

    _onContactAutocomplete: function(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(function() { ContactActions.search(input, {limit: 10}); }, 500);
        }
    },
    
    _onContactListChange: function() {
        let contacts = ContactStore.getAll(); // get by search
        if (contacts !== undefined) {
            let contactList = contacts.map(function(contact) {
                let click = this.onDialogSelect.bind(this, contact);
                return {
                    text: contact.name,
                    value: <MenuItem key={contact.id} value={contact.id} primaryText={contact.name} onTouchTap={click} />
                };
            }, this);
            let state = assign(this.state, {contactList: contactList});
            this.setState(state);
        }
    },
    
    _addContact: function(contact) {
        let index = this.state.contacts.findIndex(function(e) { return e !== undefined && e.id == contact.id; });
        if (0 > index) {
            contact.loading = true;
            let contacts = this.state.contacts;
            contacts.push(contact);
            this.setState(assign(this.state, {contacts: contacts}));
            VenueActions.addContact(this.props.id, contact.id);
            return true;
        }
        return false;
    },
    
    _removeContact: function(contactId) {
        let index = this.state.contacts.findIndex(function(e) { return e !== undefined && e.id == contactId; });
        if (0 <= index) {
            let state = this.state;
            state.contacts[index].loading = true;
            this.setState(state);
            VenueActions.removeContact(this.props.id, contactId);
        }
    },

    _getContactActions: function(contact) {
        let infoLink = '/dashboard/contact/' + contact.id;
        let editLink = '/dashboard/contact/' + contact.id + '/edit';

        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            { 
                type:'divider'
            },
            {
                link: editLink,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: contact.id,
                menuTitle: 'Remove',
                title: 'Remove Contact',
                deleteAction: this._removeContact,
                message: <span>Are you sure to remove the contact "{contact.name}" ?</span>,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    onVenueAssetChange: function() {
        const assets = VenueAssetStore.getByVenue(this.props.id);
        if (!!assets) {
            this.setState({assets});
        }
    },

    // dialog handlers:
    _closeDialog: function() {
        let state = this.state;
        state.dialog.open = false;
        this.setState(this.state);
    },
    _openDialog: function(dialog) {
        let state = this.state;
        state.dialog.open = dialog;
        state.dialog.value = null;
        this.setState(this.state);
    },
    _dialogOpener: function(dialog) {
        let self = this;
        return function() { self._openDialog(dialog); };
    },
    _dialogSave: function() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'location':
                close = this._addLocation(this.state.dialog.value);
                break;
            case 'contact':
                close = this._addContact(this.state.dialog.value);
                break;
            case 'asset':
                VenueActions.addAsset(this.props.id, Number(this.state.dialog.value));
                break;
            default:
                console.error('Error: unhandled dialog');
                close = false;
        }

        if (close) this._closeDialog();

    },
    onDialogSelect: function(element) {
        let state = this.state;
        state.dialog.value = element;
        this.setState(state);
    },

    _addLocation: function(location) {
        let ok = true;
        let state = this.state;
        if (0 <= this.state.locations.findIndex(function(e) { return e !== undefined && e.id == location.id; })) {
            ok = false;
            state.dialog.value = null;
        } else {
            VenueActions.addLocation(this.props.id, location.id);
            state.locations.push({id: location.id, loading: true});
        }
        this.setState(state);
        return ok;
    },

    _removeLocation: function(locationId) {
        let index = this.state.locations.findIndex(function(e) { return e !== undefined && e.id == locationId; });
        if (0 <= index) {
            VenueActions.removeLocation(this.props.id, locationId);
            let state = this.state;
            state.locations[index].loading = true;
            this.setState(state);
        }
    },

    _onDelete: function(entityId) {
        if (entityId === this.props.id) {
            VenueActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },
});

VenueSettings.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(VenueSettings);
